module.exports = __webpack_public_path__ + "static/media/futurefit.f67b5647.png";